<template>
    <div class="hero-video-container">
        <video 
          class="hero-video" 
          autoplay 
          loop 
          muted 
          playsinline
          title="長發地產 - 北台灣土地開發整合專家"
          aria-label="長發地產企業形象影片"
          preload="metadata"
        >
            <source src="/Demo.mp4" type="video/mp4" />
            您的瀏覽器不支援影片播放。長發地產專注北台灣土地開發整合。
        </video>
        <div class="hero-overlay">
            <h1>長發致遠  | 地產風華</h1>
            <h2>以誠信為本 創造土地價值 築起城市新榮景</h2>
        </div>
    </div>
</template>

<script>
import { useHead } from '@vueuse/head';

export default {
  name: 'HeroVideo',
  setup() {
    // 添加 VideoObject 結構化數據
    useHead({
      script: [
        {
          type: 'application/ld+json',
          children: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'VideoObject',
            name: '長發地產企業形象影片',
            description: '長發地產專注北台灣高端土地整合，提供專業的土地開發、重劃整合、區段徵收及合建開發服務',
            thumbnailUrl: '/長發外觀.jpg',
            uploadDate: '2025-01-01',
            contentUrl: '/Demo.mp4',
            embedUrl: '/Demo.mp4'
          })
        }
      ]
    });
  }
}
</script>

<style scoped>
.hero-video-container {
  position: relative;
  width: 100vw;
  height: calc(100vh + 125px); /* 視窗高度再增加 125px */
  min-height: 400px;
  overflow: hidden;
  overflow-x: hidden;
}
.hero-video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);  /* 水平、垂直置中 */
  width: max(1250px, 100vw);         /* <1250px 不再縮小，>=1250px 等比例放大 */
  height: 100%;                      /* 等高覆蓋容器 */
  object-fit: cover;                 /* 保持比例覆蓋 */
  object-position: center;           /* 置中裁切 */
}
.hero-overlay {
  position: absolute;
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%;
  display: flex; 
  flex-direction: column; 
  justify-content: center; 
  align-items: center;
  background: rgba(0,0,0,0.3);
  color: #fff;
  text-shadow: 0 2px 8px #000;
  padding: 0 20px; /* 添加左右內距以防文字貼邊 */
}

/* 調整覆蓋文字的標題尺寸（響應式） */
.hero-overlay h1 {
  font-size: clamp(36px, 6vw, 72px);
  line-height: 1.2;
  font-weight: 600;
  margin: 16px 16px;
  text-align: center;
  transform: translateY(-60px); /* 往上移動 60px */
}

.hero-overlay h2 {
  font-size: clamp(18px, 3vw, 32px);
  line-height: 1.6;
  font-weight: 400;
  margin: 16px 16px;
  text-align: center; /* 確保文字置中 */
  transform: translateY(-60px); /* 與 h1 一起往上移動 */
  max-width: 90%; /* 限制最大寬度，避免文字過長 */
}

/* 行動裝置優化 */
@media (max-width: 720px) {
  .hero-overlay {
    padding: 0 16px;
  }
  
  .hero-overlay h1 {
    transform: translateY(-40px); /* 行動裝置上移距離減少 */
    margin: 12px 8px;
  }
  
  .hero-overlay h2 {
    transform: translateY(-40px);
    margin: 12px 8px;
    max-width: 95%;
  }
}
</style> 